import { generateErrorToast } from '@g17eco/molecules/toasts';
import { useUnlockAssessmentMutation, type MaterialitySurveyModelMinData } from '../api/materiality-assessment';

export const useUnlockAssessment = () => {
  const [unlockAssessment, { isLoading }] = useUnlockAssessmentMutation();
  const handleUnlock = (survey: Pick<MaterialitySurveyModelMinData, '_id' | 'initiativeId'>, returnUrl?: string) => {
    const { _id: surveyId, initiativeId } = survey;
    unlockAssessment({ initiativeId, surveyId, returnUrl: returnUrl || window.location.pathname })
      .unwrap()
      .then((response) => {
        if (response.sessionUrl) {
          window.location.href = response.sessionUrl;
          return;
        }
      })
      .catch((e) => {
        generateErrorToast(e);
      });
  };
  return { handleUnlock, isUnlocking: isLoading };
};
